
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import LoadingModule from '../store/modules/LoadingModule';
import { StockMessage, WebProduct } from '@/models/Product';
import { CbxVariablesModule } from '@/store/modules/CbxVariablesModule';
import PriceRequestModule from '@/store/modules/PriceRequestModule';
import { PriceRequestEditModel, PriceRequestProduct } from '@/models/PriceRequest';
import { Debounce } from 'vue-debounce-decorator';

@Component({
    name: 'RequestPriceButton',
    components: {
    }
})
export default class RequestPriceButton extends Vue {
    @Prop({ type: Object, required: false, default: null }) private product: WebProduct;
    @Prop({ type: String, required: false, default: '' }) private sku: string;
    @Prop({ type: String, required: false, default: 'default' }) private size: string;
    @Prop({ type: Boolean, required: false, default: true }) private displayText: boolean;
    @Prop({ type: Boolean, required: false, default: false }) private asRedirect: boolean;
    @Prop({ type: String, required: false, default: '' }) private url: string;
    @Prop({ type: Object, required: false, default: null }) private stockMessage: StockMessage;

    private quantity: number = 1;

    get displayRequestPriceButton(): boolean {
        return !CbxVariablesModule.VARIABLES?.signinstatus;
    }

    get isCheckoutPage(): boolean {
        return window.location.pathname == CbxVariablesModule.VARIABLES?.checkoutpage;
    }

    get translationsReady(): boolean {
        return this.$root.$data.translationsLoaded === true;
    }

    get isLoading(): boolean {
        return LoadingModule.IS_LOADING;
    }

    get fallbackButtonText(): any {
        return this.$t('checkout.request-price-button', ['Request price']);
    }

    get productId(): string {
        if (this.product) {
            return this.product.id;
        } else if (this.sku) {
            return this.sku;
        }
        return 'SKU_MISSING';
    }

    get sizeClasses(): any {
        const retval: any = {
            input: '',
            button: '',
            iconRatio: '.8',
        };
        if (this.size !== 'medium') {
            retval.input = `uk-form-${this.size}`;
            retval.button = `uk-button-${this.size}`;
        }
        if (this.size === 'small') {
            retval.iconRatio = '.6';
        }
        if (this.size === 'large') {
            retval.iconRatio = '1.1';
        }

        return retval;
    }

    get itemFromLookup(): PriceRequestProduct {
        return PriceRequestModule.PRICEREQUESTS_LOOKUP[this.productId];
    }

    get priceRequestEditModel(): PriceRequestEditModel {
        return {
            productid: this.productId,
            quantity: this.quantity
        };
    }

    get colli(): number {
        if (this.product)
            return this.product.colli;
        return 1;
    }
    
    get currentStockMessage(): StockMessage {
        if (this.product)
            return this.product.stockmessage;

        return this.stockMessage;
    }

    get allowPriceRequest(): boolean {
        if (CbxVariablesModule.VARIABLES?.productStockSettings?.allowpricerequestoos)
            return true;

        return this.stockMessage.instock;
    }


    private async add() {
        if (this.isLoading && this.itemFromLookup)
            return false;

        // respect colli 
        this.priceRequestEditModel.quantity = Math.ceil(this.priceRequestEditModel.quantity / this.colli) * this.colli;
        await PriceRequestModule.ADD_TO_PRICEREQUESTS(this.priceRequestEditModel);

        if (!this.isCheckoutPage)
            PriceRequestModule.SET_IS_OPEN(true);
    }

    private isNumber(event: any) {
        return event.charCode >= 48 && event.charCode <= 57;
    }

    private async increment() {
        await this.updateQuantity(this.itemFromLookup.quantity + this.colli);
    }

    private async decrement() {
        await this.updateQuantity(this.itemFromLookup.quantity - this.colli);
    }

    private async updateQuantity(quantity: number) {
        if (typeof quantity !== 'number') {
            return;
        }

        // respect colli 
        quantity = Math.ceil(quantity / this.colli) * this.colli;

        LoadingModule.SET_LOADING(true);
        this.priceRequestEditModel.quantity = quantity;
        await PriceRequestModule.ADD_TO_PRICEREQUESTS(this.priceRequestEditModel);
        if (this.priceRequestEditModel.quantity === 0) {
            this.priceRequestEditModel.quantity = this.quantity;
        }
        LoadingModule.SET_LOADING(false);
    }

    @Watch("quantity")
    @Debounce(500)
    private onQuantityChange() {
        if (this.itemFromLookup != null)
            this.updateQuantity(this.quantity);
    }
}
